/**
 * Human-readable labels and blurbs for org billing feature flags from the API.
 * Keys match server `TIER_FEATURES` / `getEffectiveFeatures` strings.
 */
const CAPABILITY_INFO: Record<string, { label: string; description: string }> = {
  multi_persona: {
    label: 'Multi-persona sessions',
    description:
      'Run a single practice with several AI personas at once—useful for committee or multi-stakeholder scenarios.',
  },
  multi_user: {
    label: 'Multi-user practice',
    description:
      'Invite teammates into the same session and share org-visible practice links (where your plan allows).',
  },
  practice_scheduling: {
    label: 'Practice scheduling',
    description: 'Schedule practice sessions ahead of time so your team knows when to join.',
  },
  crm_connect: {
    label: 'CRM integration',
    description:
      'Connect your CRM (Salesforce, HubSpot) to generate AI personas from real customer data and pipeline patterns.',
  },
  crm_deal_personas: {
    label: 'Live deal personas',
    description:
      'Browse your open pipeline and generate buyer personas from specific deals — practice against your actual prospects.',
  },
};

export function planCapabilityDisplay(feature: string): { label: string; description: string } {
  const known = CAPABILITY_INFO[feature];
  if (known) return known;
  const label = feature.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  return {
    label,
    description: 'Included with your current plan.',
  };
}
